import draggableCursorIcon from '@atom/components/common/svgIcons/draggableCursor.svg';
import draggingCursorIcon from '@atom/components/common/svgIcons/draggingCursor.svg';
import colors from '@atom/styles/colors';

export const OUTLINE_COLOR = colors.neutral.black;
export const LINE_COLOR = colors.neutral.black;
export const VERTEX_FILL = colors.neutral.white;
export const STROKE_WEIGHT = 2;

export const CLOSE_HIT_PX = 12;
export const DRAG_THRESHOLD_PX = 4;
export const DRAWING_Z_INDEX = 1000;
export const EDIT_COMMIT_MS = 250;
export const CURSOR_RADIUS_PX = 40;

export const GRAB_CURSOR_OPTIONS: google.maps.MapOptions = {
  draggableCursor: `url(${draggableCursorIcon}) ${CURSOR_RADIUS_PX} ${CURSOR_RADIUS_PX}, auto`,
  draggingCursor: `url(${draggingCursorIcon}) ${CURSOR_RADIUS_PX} ${CURSOR_RADIUS_PX}, auto`,
  clickableIcons: false,
};
export const CROSSHAIR_CURSOR_OPTIONS: google.maps.MapOptions = {
  draggableCursor: 'crosshair',
  draggingCursor: null,
  clickableIcons: false,
};
export const DEFAULT_CURSOR_OPTIONS: google.maps.MapOptions = {
  draggableCursor: null,
  draggingCursor: null,
  clickableIcons: true,
  disableDoubleClickZoom: false,
};

// While grabbing, markers are made non-interactive so the grab click falls
// through to the map (which yields the lat/lng the grab circle is built from).
// Markers are Google's third-party `gmp-advanced-marker` elements, so this
// override lives in CSS-in-JS.
export const MARKERS_INERT_CLASS = 'atom-map-markers-inert';
export const MARKERS_INERT_STYLE_ID = 'atom-map-markers-inert-style';
